import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from './shared/services/navigation.service';
import { langCodeToName } from './shared/data/missing-translation-handler';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent {
  private navigationService = inject(NavigationService);
  translate = inject(TranslateService);

  constructor() {
    const translate = this.translate;

    // initialize translate; de and en first, alphabetically sorted afterwards
    translate.addLangs(['de', 'en-us']);
    translate.addLangs(
      [
        'fr',
        'pl',
        'it',
        'sv',
        'nl',
        'es',
        'tr',
        'bg',
        'da',
        'et',
        'fi',
        'el',
        'id',
        'lv',
        'lt',
        'nb-no',
        'pt',
        'ro',
        'sk',
        'sl',
        'cs',
        'uk',
        'hu'
      ].sort((a, b) => langCodeToName(a).localeCompare(langCodeToName(b)))
    );

    // fallback language
    translate.setFallbackLang('de');

    // default to browser language
    translate.use('de');
  }

  // scroll to top at every new component
  onActivate() {
    window.scroll(0, 0);
  }
}
